(() => {
  const GREEN = '#8A8F54';
  const BAR_BG = '#d6cebd';
  const BORDER = '#cfc6b5';
  const TEXT_MUTED = '#777267';
  const STYLE_ID = 'bk-okendo-runtime-overrides';

  const css = `
    .okeReviews .oke-w-writeReview,
    .okeReviews .oke-w-reviews-writeReview,
    .okeReviews .oke-button-primary,
    [data-oke-widget] .oke-w-writeReview,
    [data-oke-widget] .oke-w-reviews-writeReview,
    [data-oke-widget] .oke-button-primary,
    .jdgm-widget .jdgm-write-rev-link,
    .jdgm-widget .jdgm-btn--solid {
      background: ${GREEN} !important;
      border-color: ${GREEN} !important;
      color: #fff !important;
      border-radius: 8px !important;
    }
  `;

  const normalize = (value) => (value || '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .trim();

  function injectStyle() {
    if (document.getElementById(STYLE_ID)) return;
    const style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = css;
    document.head.appendChild(style);
  }

  function getRoots() {
    return Array.from(document.querySelectorAll('.okeReviews, [data-oke-widget], .okeReviews-widget-holder, [class*="okeReviews"], .jdgm-widget, .jdgm-rev-widg, [class*="jdgm"]'));
  }

  function forceButton(root) {
    root.querySelectorAll('button, a, [role="button"]').forEach((el) => {
      if (!normalize(el.textContent).includes('fazer uma avaliacao')) return;
      el.style.setProperty('background-color', GREEN, 'important');
      el.style.setProperty('border-color', GREEN, 'important');
      el.style.setProperty('color', '#ffffff', 'important');
      el.style.setProperty('border-radius', '8px', 'important');
      el.style.setProperty('font-weight', '800', 'important');
    });
  }

  function inRatingBreakdown(el) {
    return el.closest('[class*="distribution" i], [class*="Distribution"], [class*="breakdown" i], [class*="Breakdown"], .jdgm-histogram, .jdgm-histogram__row');
  }

  function forceDistributionNumbers(root) {
    root.querySelectorAll('span, div, b, i').forEach((el) => {
      if (!inRatingBreakdown(el)) return;
      const text = el.textContent.trim();
      if (!/^\d+$/.test(text)) return;
      if (el.children.length > 0) return;
      el.style.setProperty('color', TEXT_MUTED, 'important');
    });
  }

  function forceBars(root) {
    root.querySelectorAll('div, span, i, b').forEach((el) => {
      if (!inRatingBreakdown(el)) return;
      const rect = el.getBoundingClientRect();
      if (rect.width < 70 || rect.height < 1 || rect.height > 9) return;
      el.style.setProperty('height', '5px', 'important');
      el.style.setProperty('min-height', '5px', 'important');
      el.style.setProperty('background-color', BAR_BG, 'important');
      el.style.setProperty('border-radius', '999px', 'important');
      el.style.setProperty('overflow', 'hidden', 'important');

      Array.from(el.children).forEach((child) => {
        const childRect = child.getBoundingClientRect();
        if (childRect.width < 1 || childRect.height > 9) return;
        child.style.setProperty('height', '5px', 'important');
        child.style.setProperty('min-height', '5px', 'important');
        child.style.setProperty('background-color', GREEN, 'important');
        child.style.setProperty('border-radius', '999px', 'important');
      });
    });
  }

  function hasReviewText(el) {
    const text = normalize(el.textContent);
    return text.includes('foi util') || text.includes('ler mais') || text.includes('comprador verificado') || text.includes('avaliador verificado');
  }

  function roundedFrame(el) {
    el.style.setProperty('border-radius', '12px', 'important');
    el.style.setProperty('overflow', 'hidden', 'important');
    const style = getComputedStyle(el);
    if (style.borderStyle !== 'none' || style.borderWidth !== '0px') {
      el.style.setProperty('border-color', BORDER, 'important');
    }
  }

  function forceReviewCards(root) {
    root.querySelectorAll('.jdgm-rev, article, li, [class*="review" i], [class*="Review"]').forEach((el) => {
      const rect = el.getBoundingClientRect();
      if (rect.width < 180 || rect.width > 520 || rect.height < 170) return;
      if (!hasReviewText(el)) return;
      roundedFrame(el);
    });
  }

  function forcePhotoReviewCards(root) {
    root.querySelectorAll('img, picture, .jdgm-rev__pic-img').forEach((media) => {
      let node = media.parentElement;
      let best = null;
      for (let depth = 0; node && node !== root && depth < 10; depth += 1) {
        const rect = node.getBoundingClientRect();
        if (rect.width >= 180 && rect.width <= 520 && rect.height >= 230 && hasReviewText(node)) {
          best = node;
        }
        node = node.parentElement;
      }
      if (best) roundedFrame(best);
    });
  }

  function applyOkendoOverrides() {
    injectStyle();
    getRoots().forEach((root) => {
      forceButton(root);
      forceDistributionNumbers(root);
      forceBars(root);
      forceReviewCards(root);
      forcePhotoReviewCards(root);
    });
  }

  document.addEventListener('DOMContentLoaded', applyOkendoOverrides);
  window.addEventListener('load', applyOkendoOverrides);
  [250, 750, 1500, 3000].forEach((delay) => window.setTimeout(applyOkendoOverrides, delay));

  const observer = new MutationObserver(() => applyOkendoOverrides());
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
